import { useEffect } from "react";
import { useFormContext } from "react-hook-form";

import { useHubStationsContext } from "../hub-stations.context";
import {
  isUnsetHubId,
  resolveDefaultHubStationId,
} from "./hub-station-template.utils";

export const useAutoSelectDefaultHub = (
  hubFieldName: string | undefined,
): void => {
  const hubContext = useHubStationsContext();
  const { watch, setValue } = useFormContext();

  const fieldName = hubFieldName ?? "hubStationId";
  const currentHubId = watch(fieldName) as number | null | undefined;

  useEffect(() => {
    if (!hubContext || hubContext.isHubStationsLoading) {
      return;
    }

    // Do not override an explicit skip (-1) or an already chosen hub station.
    if (!isUnsetHubId(currentHubId)) {
      return;
    }

    const defaultHubId = resolveDefaultHubStationId(
      hubContext.hubStationsDropdownList,
    );

    if (!defaultHubId) {
      return;
    }

    setValue(fieldName, defaultHubId, {
      shouldDirty: true,
      shouldValidate: true,
    });
  }, [currentHubId, fieldName, hubContext, setValue]);
};
